export default __webpack_public_path__ + "static/media/blog-post.1.af5eee4e.md";